export type ShortcutString = string | string[];

export const GLOBAL_SHORTCUTS_SCOPE = 'global' as const;
export const SHAPE_SELECTION_SHORTCUTS_SCOPE = 'shapeSelection' as const;

export const GLOBAL_SHORTCUTS = {
  panTool: 'h',
  drawTool: 'r',
  circleTool: 'o',
  drawSelectTool: 'shift+r',
  iconTool: 'i',
  selectionTool: 'v',
  copy: ['meta+c', 'ctrl+c'],
  paste: ['meta+v', 'ctrl+v'],
  undo: ['meta+z', 'ctrl+z'],
  redo: ['shift+meta+z', 'shift+ctrl+z'],
  selectAll: ['meta+a', 'ctrl+a'],
  groupSelected: ['meta+g', 'ctrl+g'],
  unGroupSelected: ['shift+meta+g', 'shift+ctrl+g'],
  deselectAll: 'esc',
  wallBridgeHorizontal: 'b',
  wallBridgeVertical: 'shift+b',
  wallPathTool: 'p',
  addDoor: 'g',
  addWindow: 'w',
  removeDoor: 'shift+g',
  removeWindow: 'shift+w',
  wallExtend: 'e'
};

export const SHAPE_SELECTION_SHORTCUTS = {
  duplicate: ['meta+d', 'ctrl+d'],
  showHide: ['shift+meta+h', 'shift+ctrl+h'],
  lockUnlock: ['shift+meta+k', 'shift+ctrl+k'],
  flipHorizontal: 'shift+h',
  flipVertical: 'shift+v',
  moveToFront: ']',
  moveToBack: '[',
  delete: ['backspace', 'delete'],
  cut: ['meta+x', 'ctrl+x'],
  closeWallRect: 'shift+e',
  eyedropper: ['i', 'ctrl+c']
};

export const shortcuts = {
  [GLOBAL_SHORTCUTS_SCOPE]: GLOBAL_SHORTCUTS,
  [SHAPE_SELECTION_SHORTCUTS_SCOPE]: SHAPE_SELECTION_SHORTCUTS
} as const;
